import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

const API = import.meta.env.VITE_API_URL || 'https://cuvia.ro/api';

export const AuthProvider = ({ children }) => {
  // Incarca user si token din localStorage la mount
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const [token, setToken] = useState(() => localStorage.getItem('token') || null);

  // Set axios Authorization header
  useEffect(() => {
    if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    else delete axios.defaults.headers.common['Authorization'];
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    const { token: t, user: u } = res.data;

    // Salveaza datele in localStorage
    localStorage.setItem('token', t);
    localStorage.setItem('user', JSON.stringify(u));

    setToken(t);
    setUser(u);

    return res.data;
  };

  const register = async (email, password, role = 'guest') => {
    const res = await axios.post(`${API}/auth/register`, { email, password, role });
    const { token: t, user: u } = res.data;

    localStorage.setItem('token', t);
    localStorage.setItem('user', JSON.stringify(u));

    setToken(t);
    setUser(u);

    return res.data;
  };

  // Logout manual: curata token si user
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, setUser, setToken, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
